import React from 'react';
import PropTypes from 'prop-types';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import { Table } from 'react-bootstrap';
import XBadge from '../lib/XBadge';
import XIcon from '../lib/XIcon';
import Money from '../lib/Money';
import { FormattedNumber } from 'react-intl';
import Skeleton from 'react-loading-skeleton';

const TransactionSummary = (props) => {
  const {
    xrp_price,
    ledger_index,
    payments_count,
    transaction_count,
    accounts_created,
    ledger_interval,
    tx_per_second,
    xrp_destroyed,
   } = props;

  return (
		<Card className='shadow'>
			<Card.Body className='pb-0'>
				<Row>
					<Col xs={12} md={12}>
						<Table responsive>
							<thead>
								<tr className="text-center">
									<th className='th-light-borders'>XRP Price</th>
									<th className='th-light-borders'>Ledger</th>
									<th className='th-light-borders'>Successful payments</th>
									<th className='th-light-borders'>Transactions</th>
									<th className='th-light-borders'>Accounts created</th>
									<th className='th-light-borders'>Ledger interval</th>
									<th className='th-light-borders'>TPS</th>
									<th className='th-light-borders'>XRP Burned <small className='text-muted'>(all time)</small></th>
								</tr>
							</thead>
							<tbody>
								<tr className="text-center">
                  <td className="text-center">
                  { !Number(xrp_price) && <Skeleton width={116.7}/> }
                  { xrp_price > 0 &&
                    <XBadge variant="primary" className="text-monospace">
                    <XIcon icon='dollar-sign' className="mr-0"/>
                    <FormattedNumber value={xrp_price} minimumFractionDigits={2} maximumFractionDigits={2}/>
                    <span className='ml-1'>USD/XRP</span>
                    </XBadge>
                  }
                  </td>

                  <td className="text-center">
                  { !Number(ledger_index) && <Skeleton width={113}/> }
                  { ledger_index > 0 &&
                    <XBadge variant="info" className="text-monospace">
                    <XIcon icon='money-check' className="mr-2"/>
                    <FormattedNumber value={ledger_index}/>
                    </XBadge>
                  }
                  </td>

                  <td>
                  { !Number(payments_count) && <Skeleton width={90}/> }
                  { payments_count > 0 &&
                    <XBadge variant='success' className="text-monospace">
                    <XIcon icon='file-invoice' className="mr-2"/>
                    <FormattedNumber value={payments_count}/>
                    </XBadge>
                  }
                  </td>

                  <td>
                  { !Number(transaction_count) && <Skeleton width={90}/> }
                  { transaction_count > 0 &&
                    <XBadge variant="primary" className="text-monospace">
                    <XIcon icon='chart-network' className="mr-2"/>
                    <FormattedNumber value={transaction_count}/>
                    </XBadge>
                  }
                  </td>

                  <td>
                  { !Number(accounts_created) && <Skeleton width={75}/> }
                  { accounts_created > 0 &&
                    <XBadge variant="primary" className="text-monospace">
                    <XIcon icon='users' className="mr-2"/>
                    <FormattedNumber value={accounts_created}/>
                    </XBadge>
                  }
                  </td>

                  <td>
                  { !Number(ledger_interval) && <Skeleton width={94}/> }
                  { ledger_interval > 0 &&
                    <XBadge variant="primary" className="text-monospace">
                    <XIcon icon='stopwatch' className="mr-2"/>
                    <FormattedNumber value={ledger_interval} minimumFractionDigits={2} maximumFractionDigits={2}/>
                    <span className='ml-1'>sec</span>
                    </XBadge>
                  }
                  </td>

                  <td>
                  { !Number(tx_per_second) && <Skeleton width={110}/> }
                  { tx_per_second > 0 &&
                    <XBadge variant="primary" className="text-monospace">
                    <XIcon icon='tachometer' className="mr-2"/>
                    <FormattedNumber value={tx_per_second} minimumFractionDigits={2} maximumFractionDigits={2}/>
                    <span className='ml-1'>tx/s</span>
                    </XBadge>
                  }
                  </td>

                  <td>
                  { !Number(xrp_destroyed) && <Skeleton width={163}/> }
                  { xrp_destroyed > 0 &&
                    <XBadge variant="danger" className="text-monospace">
                    <XIcon icon='fire-smoke' className="mr-2"/>
                    <Money value={xrp_destroyed} min={2} max={2}/>
                    </XBadge>
                  }
                  </td>
                </tr>
            </tbody>
						</Table>
					</Col>
				</Row>
			</Card.Body>
		</Card>
  );

  // return (
  //   <Row>
  //     <Col xs="12" md="12">
  //     <Card className="shadow-sm">
  //       <Card.Body className="metric-card">
  //       <CardGroup>
  //         <MetricCard metric={ledger_index} icon="clipboard">Ledger</MetricCard>
  //         <MetricCard metric={payments_count} icon="money-check">Successful payments</MetricCard>
  //         <MetricCard metric={transaction_count} icon="file-invoice">Transactions</MetricCard>
  //         <MetricCard metric={accounts_created} icon="users">Accounts created</MetricCard>
  //         <MetricCard metric={ledger_interval} unit="sec" icon="stopwatch">Ledger interval</MetricCard>
  //         <MetricCard metric={tx_per_second} unit="tx/s" icon="tachometer">TPS</MetricCard>
  //         <MetricCard metric={xrp_destroyed} icon="fire-smoke">XRP Burned <small>(all time)</small></MetricCard>
  //       </CardGroup>
  //       </Card.Body>
  //     </Card>
  //     </Col>
  //   </Row>
  // );
}

TransactionSummary.propTypes = {
  ledger_index: PropTypes.number,
  payments_count: PropTypes.number,
  transaction_count: PropTypes.number,
  accounts_created: PropTypes.number,
  ledger_interval: PropTypes.number,
  tx_per_second: PropTypes.number,
  xrp_destroyed: PropTypes.number,
};

export default TransactionSummary;
